import {
  TransactionStatusQuery,
  TransactionStatusQueryVariables
} from '@data/__generated__/types.main'
import gql from 'graphql-tag'

import useQueryWithConditionalPolling from './useQueryWithConditionalPolling'

function isOrderFinal(order: TransactionStatusQuery['order']) {
  if (!order) return false
  if (order.orderStatus === 'pending') return false
  if (order.paymentStatus === 'pending') return false
  return true
}

function useTransactionStatus(orderId: string, opts: {pollInterval?: number} = {}) {
  const {pollInterval} = opts
  const {data, refetch} = useQueryWithConditionalPolling<
    TransactionStatusQuery,
    TransactionStatusQueryVariables
  >({
    query: gql`
      query TransactionStatus($orderId: ID!) {
        order(orderId: $orderId) {
          _id
          orderStatus
          paymentStatus
          paymentType

          transaction {
            _id
            status
          }
          intent {
            _id
            status
          }
        }
      }
    `,
    variables: {
      orderId
    },
    fetchPolicy: 'cache-first',
    ...(pollInterval ? {pollInterval} : {}),
    omit: !orderId
  })

  return {order: data.order, refetch: () => refetch({orderId})}
}

const useShouldRedirectToPaymentGateway = (
  orderId: string,
  opts: {pollInterval?: number} = {}
): boolean => {
  const {order} = useTransactionStatus(orderId, {pollInterval: opts.pollInterval})
  if (!order) return false

  if (order?.paymentStatus === 'done') {
    return false
  }

  if (order?.paymentStatus === 'inReview') {
    return true
  }

  if (['pending', 'error'].includes(order?.transaction?.status)) {
    return true
  }
  if (order?.intent && order.intent.status !== 'completed') {
    return true
  }

  return false
}

export default useShouldRedirectToPaymentGateway
